import { render } from "./BotNav.vue?vue&type=template&id=89f00cfc&scoped=true"
import script from "./BotNav.vue?vue&type=script&lang=js"
export * from "./BotNav.vue?vue&type=script&lang=js"

import "./BotNav.vue?vue&type=style&index=0&id=89f00cfc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89f00cfc"]])

export default __exports__